import React, { useEffect, useRef, useState } from "react";
import Select from "react-select";

// components
import ErrorMessage from "../../../../../Shared/error-message/errorMessage";
import InputField from "../../Shared/inputField/inputField";


// Styles
import Styles from "../../Shared/sharedStyles.module.scss";
import dropDownStyles from "../../../../../Shared/dropDownStyles";
import {
  buttonStyles,
  StyledButton,
} from "../../../../../Shared/button/button";

// Constants
import { days, dobYears, months } from "../../../../../constants/data";


// Functions
import { checkPAN, validNameCheck } from "../../../../../utils/validation";
import { IdsGenerator } from "../../../../../utils/idGenerator";

function PanServicePopup({ handleResponse, name }: any) {
  const serviceName = name.replaceAll(" ", "").toLowerCase();
  const dateRef = useRef<any>(null);
  const monthRef = useRef<any>(null);
  const yearRef = useRef<any>(null);

  const [day, setDay] = useState("");
  const [month, setMonth] = useState("");
  const [year, setYear] = useState("");

  const errorObject = {
    panNumberError: false,
    consentError: false,
    dobDayError: false,
    dobMonthError: false,
    dobYearError: false,
    nameToMatchError: false,
    userNameError: false,
  };

  const [error, setError] = useState({ ...errorObject });
  const [isChecked, setIsChecked] = useState(false);
  const [isDisabled, setIsDisabled] = useState(true);
  const [loading, setLoading] = useState(false);
  const [panDetails, setPanDetails] = useState(false);
  const nameMatchRef = useRef<any>("");
  const userNameref = useRef<any>("");
  const [isNameMatchEnabled, setIsNameMatchEnabled] = useState(false);

  const panNumberRef = useRef<any>("");

  useEffect(() => {
    if (isNameMatchEnabled) {
      setIsDisabled(true);
    }
    if (!isNameMatchEnabled) {
      if (panNumberRef.current.value) {
        setIsDisabled(false);
      }
    }
  }, [isNameMatchEnabled]);

  function isValidNameMatch() {
    setError({ ...errorObject });
    if (
      checkPAN(panNumberRef.current.value.trim().toUpperCase()) &&
      validNameCheck(nameMatchRef.current.value)
    ) {
      setError(errorObject);
      return setIsDisabled(false);
    }
    if (!checkPAN(panNumberRef.current.value.trim().toUpperCase())) {
      setError(() => ({
        ...error,
        panNumberError: true,
      }));
    }
    if (!validNameCheck(nameMatchRef.current.value)) {
      setError(() => ({
        ...error,
        nameToMatchError: true,
      }));
    }
    return setIsDisabled(true);
  }

  function isValid() {
    if (checkPAN(panNumberRef.current.value.trim().toUpperCase())) {
      setError(errorObject);
      return setIsDisabled(false);
    }
    setError(() => ({
      ...error,
      panNumberError: true,
    }));

    return setIsDisabled(true);
  }

  function handleCheck() {
    const panNumber = panNumberRef.current.value.toUpperCase();
    const userName = userNameref.current.value;
    const consent = isChecked === true ? "Y" : "N";
    if (isNameMatchEnabled && nameMatchRef.current.value === "") {
      setError(() => ({
        ...error,
        nameToMatchError: true,
      }));
      return setIsDisabled(true);
    }

    if (serviceName === "pandemographic") {
      if (userNameref.current.value === "") {
        setError(() => ({
          ...error,
          userNameError: true,
        }));
        return setIsDisabled(true);
      }
      if (!day) {
        setError(() => ({
          ...error,
          dobDayError: true,
        }));
        return false;
      }
      if (!month) {
        setError(() => ({
          ...error,
          dobMonthError: true,
        }));
        return false;
      }
      if (!year) {
        setError(() => ({
          ...error,
          dobYearError: true,
        }));
        return false;
      }
    }

    if (!isChecked) {
      setError(() => ({
        ...error,
        consentError: true,
      }));
      return false;
    }
    setLoading(true);
    if (serviceName === "pandemographic") {
      const dob = `${day}-${month}-${year}`;
      handleResponse({ panNumber, dob, consent, userName }, setLoading);
    } else if (serviceName === "panmicro") {
      handleResponse({ panNumber, consent, panDetails }, setLoading);
    } else if (
      nameMatchRef &&
      nameMatchRef.current &&
      nameMatchRef.current.value
    ) {
      const panHolderName = nameMatchRef.current.value;
      handleResponse({ panNumber, panHolderName, consent }, setLoading);
    } else handleResponse({ panNumber, consent }, setLoading);
  }
  return (
    <div className={`${Styles.content}`}>
      <div className={`${Styles.infoForm} pl-2`}>
        <hr />
        <p className="mt-2">Fill in the below details to run verification</p>
        <div className="d-flex flex-column">
          <div className="d-flex flex-column mb-4 ">
            <label className={`${Styles.label} flex-grow-1`}>PAN Number</label>
            <InputField
              id={IdsGenerator({
                prefix: "pan service popup",
                id: "change",
                suffix: "pan number",
              })}
              onChange={isValid}
              maxLength={10}
              inputRef={panNumberRef}
              isError={error.panNumberError}
              purpose="forPan"
            />
            {error.panNumberError && (
              <ErrorMessage>Please enter a valid Pan number</ErrorMessage>
            )}
          </div>
          {serviceName === "pandemographic" && (
            <>
              <div className="d-flex flex-column mb-4 ">
                <label className={`${Styles.label} flex-grow-1`}>
                  User name
                </label>
                <InputField
                  id={IdsGenerator({
                    prefix: "pan service popup",
                    id: "change",
                    suffix: `${serviceName} username`,
                  })}
                  text="lowercase"
                  onChange={isValid}
                  inputRef={userNameref}
                  isError={error.userNameError}
                  purpose="forPan"
                />
                {error.userNameError && (
                  <ErrorMessage>Please enter user name</ErrorMessage>
                )}
              </div>
              <label className={`${Styles.label}`}>DOB</label>
              <div className="d-flex mr-1">
                <div className="mr-2 d-flex gap-2">
                  <div className="d-flex flex-column">
                    <Select
                      id={IdsGenerator({
                        prefix: "pan service popup",
                        id: "select",
                        suffix: `${serviceName} date`,
                      })}
                      ref={dateRef}
                      onChange={(e: any) => setDay(e.value)}
                      options={days}
                      styles={
                        !error.dobDayError
                          ? dropDownStyles.customStylesForDays
                          : dropDownStyles.customStylesForDaysError
                      }
                      placeholder="DD"
                    />
                  </div>
                  <div className="ml-2 d-flex flex-column">
                    <Select
                      id={IdsGenerator({
                        prefix: "pan service popup",
                        id: "select",
                        suffix: `${serviceName} month`,
                      })}
                      onChange={(e: any) => setMonth(e.value)}
                      ref={monthRef}
                      options={months}
                      styles={
                        !error.dobMonthError
                          ? dropDownStyles.customStylesForMonths
                          : dropDownStyles.customStylesForMonthsError
                      }
                      placeholder="MMM"
                    />
                  </div>
                  <div className="ml-2 d-flex flex-column">
                    <Select
                      id={IdsGenerator({
                        prefix: "pan service popup",
                        id: "select",
                        suffix: `${serviceName} year`,
                      })}
                      onChange={(e: any) => setYear(e.value)}
                      ref={yearRef}
                      placeholder="YYYY"
                      options={dobYears}
                      styles={
                        !error.dobYearError
                          ? dropDownStyles.customStylesForYears
                          : dropDownStyles.customStylesForYearsError
                      }
                    />
                  </div>
                </div>
              </div>
            </>
          )}

          {(serviceName === "panpro" ||
            serviceName === "panlite" ||
            serviceName === "panadvance") && (
            <div className="pl-4 pb-2 pt-4 d-flex flex-column">
              <div className="d-flex align-items-center py-0">
                <input
                  id={IdsGenerator({
                    prefix: "pan service popup",
                    id: "check",
                    suffix: `${serviceName} is name match required`,
                  })}
                data-testid={IdsGenerator({
                    prefix: "pan service popup",
                    id: "check",
                    suffix: `${serviceName} is name match required`,
                  })}
                  type="checkbox"
                  className={`${Styles.formCheckInput} me-2`}
                  onChange={(e: any) => setIsNameMatchEnabled(e.target.checked)}
                  style={{ margin: 0 }}
                />
                <p className={`${Styles.ackText} mb-0`}>
                  is name match required?
                </p>
              </div>
            </div>
          )}

          {serviceName === "panmicro" && (
            <div className="pl-4 pb-2 pt-4 d-flex flex-column">
              <div className="d-flex align-items-center py-0 gap-2">
                <input
                  id={IdsGenerator({
                    prefix: "pan service popup",
                    id: "check",
                    suffix: `${serviceName} is pan details required`,
                  })}
                data-testid={IdsGenerator({
                    prefix: "pan service popup",
                    id: "check",
                    suffix: `${serviceName} is pan details required`,
                  })}
                  type="checkbox"
                  className={`${Styles.formCheckInput} `}
                  onChange={(e: any) => setPanDetails(e.target.checked)}
                />
                <p
                  className={`${Styles.ackText} mb-0`}
                  style={{ lineHeight: "1", margin: 0 }}
                >
                  is pan details required?
                </p>
              </div>
            </div>
          )}

          {(serviceName === "panpro" ||
            serviceName === "panlite" ||
            serviceName === "panadvance") &&
            isNameMatchEnabled && (
              <div className="d-flex flex-column mb-4 ">
                <label className={`${Styles.label} flex-grow-1`}>
                  Name To Match
                </label>
                <InputField
                  id={IdsGenerator({
                    prefix: "pan service popup",
                    id: "change",
                    suffix: `${serviceName} name match`,
                  })}
                  onChange={isValidNameMatch}
                  inputRef={nameMatchRef}
                  isError={error.nameToMatchError}
                  purpose="forPassport"
                  text="lowerCase"
                />
                {error.nameToMatchError && (
                  <ErrorMessage>Please enter a valid Name</ErrorMessage>
                )}
              </div>
            )}

          <div className="pt-4 pl-4 pb-4 mt-4 d-flex flex-column">
            <div className="d-flex align-items-center py-0 gap-2">
              <input
                id={IdsGenerator({
                  prefix: "pan service popup",
                  id: "check",
                  suffix: "consent",
                })}
                data-testid={IdsGenerator({
                  prefix: "pan service popup",
                  id: "check",
                  suffix: "consent",
                })}
                type="checkbox"
                className={`${Styles.formCheckInput} `}
                onChange={(e: any) => {
                  setIsChecked(e.target.checked);
                  isNameMatchEnabled ? isValidNameMatch() : isValid();
                }}
              />
              <p className={`${Styles.ackText} mb-0`}>
                I hereby agree, to let zoop.one verify my data for verification
              </p>
            </div>
            {error.consentError && (
              <ErrorMessage>Please provide consent!</ErrorMessage>
            )}
          </div>
          <div className={`${Styles.buttonGroup}`}>
            <StyledButton
              id={IdsGenerator({
                prefix: "pan service popup",
                id: "click",
                suffix: "run verification",
              })}
              hoverStyle={{ ...buttonStyles.primary.hover }}
              disabled={isDisabled}
              isLoading={loading}
              style={{ ...buttonStyles.primary.normal }}
              onClick={() => {
                setTimeout(() => setError({ ...errorObject }), 2000);
                handleCheck();
              }}
            >
              Run Verification
            </StyledButton>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PanServicePopup;
